import React from 'react';
import Icon from '../../../components/AppIcon';

const ClientHistoryPanel = ({ clientId, history = [] }) => {
  const getStatusIcon = (status) => {
    const icons = {
      'completado': 'CheckCircle2',
      'en-proceso': 'Clock',
      'cancelado': 'XCircle',
      'aprobado': 'CheckCircle'
    };
    return icons?.[status] || 'FileText';
  };

  const getStatusColor = (status) => {
    const colors = {
      'completado': 'text-success',
      'en-proceso': 'text-primary',
      'cancelado': 'text-error',
      'aprobado': 'text-accent'
    };
    return colors?.[status] || 'text-muted-foreground';
  };

  if (!history || history?.length === 0) {
    return (
      <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
        <div className="flex items-center gap-2 md:gap-3 mb-4">
          <div className="p-2 rounded-lg bg-secondary/10">
            <Icon name="History" size={24} className="text-secondary" />
          </div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            Historial del Cliente
          </h3>
        </div>
        
        <div className="text-center py-8 md:py-12">
          <Icon name="FileX" size={48} className="text-muted-foreground mx-auto mb-3 md:mb-4" />
          <p className="text-sm md:text-base caption text-muted-foreground">
            No hay historial disponible para este cliente
          </p>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-card rounded-lg border border-border shadow-elevation-1 p-4 md:p-6">
      <div className="flex items-center gap-2 md:gap-3 mb-4 md:mb-6">
        <div className="p-2 rounded-lg bg-secondary/10">
          <Icon name="History" size={24} className="text-secondary" />
        </div>
        <div>
          <h3 className="text-lg md:text-xl font-heading font-semibold text-foreground">
            Historial del Cliente
          </h3>
          <p className="text-xs md:text-sm caption text-muted-foreground">
            {history?.length} {history?.length === 1 ? 'orden' : 'órdenes'} de trabajo
          </p>
        </div>
      </div>
      <div className="space-y-3 md:space-y-4">
        {history?.map((order, index) => (
          <div 
            key={index}
            className="p-3 md:p-4 rounded-lg bg-muted/30 border border-border hover:bg-muted transition-smooth"
          >
            <div className="flex items-start justify-between gap-3 mb-2 md:mb-3">
              <div className="flex items-start gap-2 md:gap-3 flex-1 min-w-0">
                <Icon 
                  name={getStatusIcon(order?.status)} 
                  size={20} 
                  className={`${getStatusColor(order?.status)} mt-0.5 flex-shrink-0`}
                />
                <div className="flex-1 min-w-0">
                  <h4 className="text-sm md:text-base font-body font-semibold text-foreground mb-1">
                    {order?.folioOT}
                  </h4>
                  <p className="text-xs md:text-sm caption text-muted-foreground truncate">
                    {order?.vehiculo}
                  </p>
                </div>
              </div>
              
              <span className="text-xs md:text-sm caption text-muted-foreground whitespace-nowrap">
                {new Date(order.fecha)?.toLocaleDateString('es-MX', { 
                  day: '2-digit', 
                  month: 'short', 
                  year: 'numeric' 
                })}
              </span>
            </div>

            <div className="grid grid-cols-2 gap-2 md:gap-3 text-xs md:text-sm">
              <div>
                <span className="caption text-muted-foreground block mb-1">Monto Total</span>
                <span className="font-body font-semibold text-foreground">
                  ${order?.montoTotal?.toLocaleString('es-MX', { minimumFractionDigits: 2 })}
                </span>
              </div>
              <div>
                <span className="caption text-muted-foreground block mb-1">Estado</span>
                <span className={`font-body font-medium ${getStatusColor(order?.status)}`}>
                  {order?.statusLabel}
                </span>
              </div>
            </div>

            {order?.servicios && order?.servicios?.length > 0 && (
              <div className="mt-2 md:mt-3 pt-2 md:pt-3 border-t border-border">
                <span className="text-xs caption text-muted-foreground block mb-1.5 md:mb-2">
                  Servicios realizados:
                </span>
                <div className="flex flex-wrap gap-1.5 md:gap-2">
                  {order?.servicios?.map((servicio, idx) => (
                    <span 
                      key={idx}
                      className="px-2 py-1 rounded-md bg-primary/10 text-primary text-xs font-body"
                    >
                      {servicio}
                    </span>
                  ))}
                </div>
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ClientHistoryPanel;